import React, { useState } from "react";
// Todo use scoped css
import OpenAccessIcon from "./open_access_orange.svg";

const Publications = ({ publication, type_short }) => {
  return (
    <>
      {Object.keys(publication).map((key) => (
        <dd key={publication[key]["id"]}>
          <span
            dangerouslySetInnerHTML={{ __html: publication[key]["html"] }}
          />

          {publication[key]["open_access"] === "Ja" ? (
            <a
              className="openaccess_link"
              href={publication[key]["url"]}
              title="Open Access"
            >
              <img
                alt="Open Access"
                title="Open Access"
                className="open_access"
                src={OpenAccessIcon}
              />
            </a>
          ) : (
            ""
          )}

          {publication[key]["link_biblform"] ? (
            <span
              title="download citation"
              className="citation"
              dangerouslySetInnerHTML={{
                __html: publication[key]["link_biblform"],
              }}
            />
          ) : (
            ""
          )}
        </dd>
      ))}
    </>
  );
};
export default Publications;
